export const FETCH_PROMOTIONS_DATA = "FETCH_PROMOTIONS_DATA";
export const FETCH_PROMOTIONS_SUCCESS = "FETCH_PROMOTIONS_SUCCESS";
export const FETCH_PROMOTIONS_FAILURE = "FETCH_PROMOTIONS_FAILURE";

export const FETCH_PROMOTIONS_EDIT_DATA = "FETCH_PROMOTIONS_EDIT_DATA";
export const FETCH_PROMOTIONS_EDIT_SUCCESS = "FETCH_PROMOTIONS_EDIT_SUCCESS";
export const FETCH_PROMOTIONS_EDIT_FAILURE = "FETCH_PROMOTIONS_EDIT_FAILURE";